export default {
	all: 'الكل',
	favorite: 'المفضلة',

	'edit-fav-list': 'تعديل المواد المفضلة',

	'total-without-vat': 'المجموع بدون الضريبة',
	'total-net': 'الصافي',
	paid: 'مدفوع',
	unpaid: 'متبقي',
	alert: 'تنبيه',
	'alert-message': 'سيتم تغير أسعار المواد إلى الأسعار المخصصة لهذا الحساب إن وجدت',
	'search-products': 'البحث عن منتجات',
	'main-items': 'العناصر الرئيسية',
	'invoice-details': 'تفاصيل الفاتورة',
	extra: 'إضافات',
	'all-favorites': 'كل المواد المفضلة',
	'did-not-add-any-items-yet': 'لم تقم بإضافة أية عناصر بعد.',
	'choose-item-to-add': 'قم إختيار عنصر لإضافته مع امكانية التعديل على الكمية.'
}